module.exports = __webpack_public_path__ + "static/media/DSC04200.fe1ef69a.jpg";